import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { StoresRepository } from '../repositories/StoresRepository';

export interface IExpandedId {
    [key: string]: string | '';
}

export class ExpandedStoreHoursIdUseCase {
    private expandedId: IExpandedId;
    private listType: string;
    private storeId: string;
    private storesRepository: StoresRepository;

    constructor(listType?: string, storeId?: string) {
        this.expandedId = {};
        this.listType = listType || '';
        this.storeId = storeId || '';
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
    }

    public execute = () => {
        this.expandedId = { ...this.expandedId, [this.listType]: this.storeId };
        this.storesRepository.setExpandedStoreHoursId(this.expandedId);
    };
}
